import { JSX } from "react";

import NotificationCard from "@/components/cards/NotificationCard.tsx";

import { Notification } from "@/api/user/user.types.ts";

interface NotificationsListProps {
  notifications: Notification[];
}

const NotificationsList = ({ notifications }: NotificationsListProps): JSX.Element => {
  return (
    <div className={"divide-y divide-surface-container"}>
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={"rounded-2xl px-4 py-5 transition-colors max-md:px-0 max-md:py-6 md:hover:bg-surface-container"}
        >
          <NotificationCard {...notification} />
        </div>
      ))}
    </div>
  );
};

export default NotificationsList;
